<template>
	<div class="attachments">
		<v-tooltip v-for="(attachment, index) in post.attachments" :key="index" top >
			<template v-slot:activator="{ on, attrs }">
				<v-btn v-bind="attrs" v-on="on" :href="attachment.url_download" solo light depressed class="mr-2 mb-2">
					<v-icon class="mr-2">mdi-attachment</v-icon> {{ attachment.original_name }}
				</v-btn>
			</template>
			{{ $vuetify.lang.t('$vuetify.views.wall.attachments.download') }} 
		</v-tooltip>
	</div>
</template>

<script>
export default {
	props: {
		post: {
			type: Object,
			required: true
		}
	},
}
</script>